import { LEGEND_SET_STATE, LEGEND_UPDATE_STATE } from './constants';
import { PANEL } from '@tmapy/config';
import { actionSetPanel } from '@tmapy/ui-manager';
export const actionDeactivateLegend = () => (dispatch) => {
    dispatch(actionSetPanel(PANEL.NONE));
};
export const actionSetLegendState = (payload) => ({
    type: LEGEND_SET_STATE,
    payload,
});
export const actionUpdateLegendState = (payload) => ({
    type: LEGEND_UPDATE_STATE,
    payload,
});
//# sourceMappingURL=actions.js.map